module.exports = __webpack_public_path__ + "static/media/help.11fe32c5.png";